import { ModelBaseModel } from '../model-base/model-base.model'
import { IUserDocument, TDocumentShareViaEmail } from './user-documents.interface'

// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
/**
 * Holds the models to store events
 */

export class UserDocumentModel extends ModelBaseModel<IUserDocument> {
  public id: string

  public riderId: IUserDocument['riderId']
  public riderName: IUserDocument['riderName']

  public horseId: IUserDocument['horseId']
  public horseName: IUserDocument['horseName']

  public signatoryId: IUserDocument['signatoryId']
  public signatoryName: IUserDocument['signatoryName']
  public signatoryProfilePicture: IUserDocument['signatoryProfilePicture']
  public signatoryDefaultRole: IUserDocument['signatoryDefaultRole']
  public signatoryEmail: IUserDocument['signatoryEmail']
  public dateOfSignature: IUserDocument['dateOfSignature']

  public status: IUserDocument['status']

  public eventId: IUserDocument['eventId']
  public eventName: IUserDocument['eventName']
  public eventLogo: IUserDocument['eventLogo']

  public documentName: IUserDocument['documentName']
  public documentUrl: IUserDocument['documentUrl']
  public documentOriginalName: IUserDocument['documentOriginalName']
  public documentNameAsPerPdf: IUserDocument['documentNameAsPerPdf']
  public documentShareViaEmail: TDocumentShareViaEmail[]
  public documentOwner: IUserDocument['documentOwner']

  public pageNumberToSignOn: IUserDocument['pageNumberToSignOn']
  public coordinatesToSignOn: IUserDocument['coordinatesToSignOn']

  public competitorId: IUserDocument['competitorId']
  public activityUser: IUserDocument['activityUser']

  public registrationDocId: IUserDocument['registrationDocId']
  public riderTeamMemberDocId: IUserDocument['riderTeamMemberDocId']
  public reminder: IUserDocument['reminder']

  public created: IUserDocument['created']
  public modified: IUserDocument['modified']

  public constructor(obj?: IUserDocument) {
    super()
    this.id = obj?.id ?? ''
    this.signatoryId = obj?.signatoryId ?? ''
    this.riderId = obj?.riderId ?? ''
    this.signatoryName = obj?.signatoryName ?? ''
    this.pageNumberToSignOn = obj?.pageNumberToSignOn ?? null
    this.coordinatesToSignOn = obj?.coordinatesToSignOn ?? {
      x: null,
      y: null,
    }
    this.signatoryProfilePicture = obj?.signatoryProfilePicture ?? ''
    this.signatoryProfilePicture = obj?.signatoryProfilePicture ?? ''
    this.status = obj?.status ?? 'Not Signed'
    this.eventId = obj?.eventId ?? ''
    this.documentName = obj?.documentName ?? ''
    this.documentUrl = obj?.documentUrl ?? ''
    this.eventName = obj?.eventName ?? ''
    this.eventLogo = obj?.eventLogo ?? ''
    this.registrationDocId = obj?.registrationDocId ?? ''
    this.riderTeamMemberDocId = obj?.riderTeamMemberDocId ?? ''
    this.documentOriginalName = obj?.documentOriginalName ?? ''
    this.documentNameAsPerPdf = obj?.documentNameAsPerPdf ?? ''
    this.documentOwner = obj?.documentOwner ?? ''
    this.documentShareViaEmail = obj?.documentShareViaEmail ?? []
    this.competitorId = obj?.competitorId ?? ''
    this.signatoryDefaultRole = obj?.signatoryDefaultRole ?? ''
    this.signatoryEmail = obj?.signatoryEmail ?? ''
    this.reminder = obj?.reminder ?? false
    this.activityUser = obj?.activityUser ?? ''
    this.riderName = obj?.riderName ?? ''
    this.horseId = obj?.horseId ?? ''
    this.horseName = obj?.horseName ?? ''

    this.dateOfSignature = obj?.dateOfSignature
      ? this.utcTimestamp({
          key: 'dateOfSignature',
          isTimestamp: true,
          value: obj?.dateOfSignature,
        })
      : null

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified ?? new Date().toString(),
    })
  }

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * @TODO Document this
   */
  static fromFirestoreDoc(doc: any) {
    return new UserDocumentModel({
      ...doc.data(),
      id: doc.id,
    })
  }
}
